import type {
  BookingCustomerOverviewApiData,
  BookingCustomerOverviewApiResponses,
  BookingItemsForServiceWorkerListApiData,
  BookingItemsForServiceWorkerListApiResponses,
  BookingMarkAsStartedApiData,
  BookingMarkAsStartedApiResponses,
  GarageBookingDailyCountsForServiceWorkerApiData,
  GarageBookingDailyCountsForServiceWorkerApiResponses,
  GarageBookingForServiceWorkerListApiData,
  GarageBookingForServiceWorkerListApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

/** Garage bookings worked by service workers without a route (worker app). */
export const garageBookingUrls = {
  getGarageBookingsForServiceWorker: dataEndpoint<
    GarageBookingForServiceWorkerListApiData,
    GarageBookingForServiceWorkerListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('bookings/garage-bookings-for-service-worker/', queryParams)
  }),
  getGarageBookingDailyCountsForServiceWorker: dataEndpoint<
    GarageBookingDailyCountsForServiceWorkerApiData,
    GarageBookingDailyCountsForServiceWorkerApiResponses
  >({
    getUrl: (queryParams) => apiUrl('bookings/garage-booking-daily-counts-for-service-worker/', queryParams)
  }),
  getBookingCustomerOverview: dataEndpoint<BookingCustomerOverviewApiData, BookingCustomerOverviewApiResponses>({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/customer-overview/`)
  }),
  getBookingItemsForServiceWorker: dataEndpoint<
    BookingItemsForServiceWorkerListApiData,
    BookingItemsForServiceWorkerListApiResponses
  >({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/booking-items-for-service-worker/`)
  }),
  postMarkBookingStarted: responseEndpoint<BookingMarkAsStartedApiData, BookingMarkAsStartedApiResponses>({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/mark-as-started/`),
    getBody: ({ startedAt }) => ({ startedAt })
  })
};
